import React from "react";
import StepHeader from "../components/StepHeader";
import OptionCard from "../components/OptionCard";
import OptionGroup from "../components/OptionGroup";
import InfoNote from "../components/InfoNote";
import ContinueButton from "../components/ContinueButton";

/**
 * I-03 / C-02 (income) and I-04 / C-03 (assets). `question` is QUESTIONS.income or QUESTIONS.assets;
 * the wording switches between individual and company. `value` is true, false or null (not answered).
 */
function YesNoStep({
  question,
  accountType,
  value,
  onChange,
  onContinue,
  onBack,
  onClose,
  busy,
  step,
  totalSteps,
  continueLabel,
}) {
  const copy = question[accountType];
  const headerTitle = accountType === "CORPORATE" ? "Company eligibility" : "Eligibility";

  // The income step says the answer is stored; the asset step explains the classification rule instead.
  let note = "Your answer is self-declared and saved to your customer profile.";
  let noteTone = "secure";
  if (copy.note) {
    note = copy.note;
    noteTone = accountType === "CORPORATE" ? "warning" : "info";
  }

  return (
    <>
      <StepHeader title={headerTitle} onBack={onBack} onClose={onClose} step={step} totalSteps={totalSteps} />

      <div className="kv-body">
        <p className="kv-eyebrow">{question.eyebrow}</p>
        <h2 className="kv-title">{copy.title}</h2>
        <p className="kv-lead">{copy.hint}</p>

        <OptionGroup label={copy.title}>
          <OptionCard
            icon="ri-check-line"
            title="Yes"
            subtitle={question.yes}
            selected={value === true}
            onSelect={() => onChange(true)}
            disabled={busy}
          />
          <OptionCard
            icon="ri-close-line"
            title="No"
            subtitle={question.no}
            selected={value === false}
            onSelect={() => onChange(false)}
            disabled={busy}
          />
        </OptionGroup>

        <InfoNote tone={noteTone}>{note}</InfoNote>
      </div>

      <ContinueButton onClick={onContinue} disabled={typeof value !== "boolean"} busy={busy}>
        {continueLabel}
      </ContinueButton>
    </>
  );
}

export default YesNoStep;
